"use strict";

document.addEventListener('BaseDataLoaded', () => {
  /**
   * app promo block
   */
  if (window.getSettingsFromApi('disable_mobile_app_promo') && window.isMob) {
    document.querySelector('.js_setDisabledByFeSettingClass').classList.add('disabled_by_fe_setting');
  }
  const keywordsLinks = document.querySelectorAll('.article_keywords__link');
  keywordsLinks.forEach(keywordsLink => {
    keywordsLink.addEventListener('click', e => {
      const isAnonymous = !window.getUserToken();
      if (isAnonymous) {
        e.preventDefault();
        window.openModalWelcome('keywords', keywordsLink.dataset.slug, keywordsLink.dataset.id);
      }
    });
  });
});
window.addEventListener('DOMContentLoaded', () => {
  const articleGallery = document.querySelector('.article-type-gallery');
  if (articleGallery) {
    const articleFeed = document.querySelector('.article-feed.site_wrap');
    if (articleFeed && articleFeed.classList.contains('hidden')) articleFeed.classList.remove('hidden');
  }

  /**
   * Adds a class indicating that this is a plus+ user.
   * That class is usually added inside the feed.js file,
   * but the live article does not have a feed like other types of articles.
   */
  const articleLive = document.querySelector('.site_wrap.is-live');
  if (articleLive) window.setPremiumClass();
});